import React, { useId } from "react";

function ErrorAlert({ message }) {
  const id = useId();

  return (
    <div
      className={`absolute w-2/3 top-5 bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 `}
      role="alert"
      data-dismissible={id}
    >
      <p className="font-bold">Error</p>
      <p>{message}</p>
      <button
        // onClick={() => setShow("hidden")}
        

        className="!absolute  top-3 right-3 h-8 max-h-[32px] w-8 max-w-[32px] select-none rounded-lg text-center align-middle font-sans text-2xl font-medium uppercase  transition-all hover:bg-white/10 active:bg-white/30 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        type="button"
      >
      <span className="absolute transform -translate-x-1/2 -translate-y-1/4 top-1/2 left-1/2">
        <i className="ri-close-large-fill w-6 h-6" data-dismissible-target={id} ></i>
        </span>
      </button>
    </div>
  );
}

export default ErrorAlert;
